import type { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import type { EverflowAttribution } from "@/features/analytics/triggers/customer-io";
import { triggerCustomerIoAffiliateIdCaptured } from "@/features/analytics/triggers/customer-io";
import type { OnboardingUser } from "@/features/onboarding/models";

interface TrackAffiliateIdCapturedParams {
  customerIoAnalytics: AnalyticsBrowser;
  email: OnboardingUser["email"];
  affiliateId?: string | null;
  everflowAttribution?: EverflowAttribution;
}

export const trackAffiliateIdCaptured = ({
  customerIoAnalytics,
  email,
  affiliateId,
  everflowAttribution,
}: TrackAffiliateIdCapturedParams) => {
  triggerCustomerIoAffiliateIdCaptured({
    analytics: customerIoAnalytics,
    email,
    affiliateId,
    everflowAttribution,
  });
};
